import * as React from "react";
import type { SVGProps } from "react";
const SvgHubspotLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={264}
    height={264}
    fill="none"
    viewBox="0 0 264 264" {...props}
  >
    <path fill="#FB7551" d="M0 0h264v264H0z" />
    <path
      fill="#fff"
      d="M179.862 99.894V77.509a17.24 17.24 0 0 0 9.939-15.537v-.513c0-9.52-7.718-17.238-17.237-17.238h-.514c-9.521 0-17.238 7.718-17.238 17.238v.513a17.23 17.23 0 0 0 9.939 15.537v22.385a48.8 48.8 0 0 0-23.21 10.218l-61.39-47.817c.437-1.58.666-3.205.691-4.836a19.42 19.42 0 1 0-19.446 19.383 19.2 19.2 0 0 0 9.564-2.602l60.452 47.041c-11.114 16.79-10.816 38.671.749 55.153l-18.386 18.392a15.8 15.8 0 0 0-4.595-.749c-8.806.008-15.94 7.149-15.937 15.954.002 8.805 7.14 15.942 15.945 15.945 8.806.002 15.947-7.132 15.954-15.937a15.8 15.8 0 0 0-.749-4.595l18.189-18.195c16.252 12.511 38.574 13.589 55.956 2.702s26.154-31.443 21.989-51.525c-4.164-20.084-20.386-35.454-40.665-38.532m-7.539 73.62a25.17 25.17 0 0 1-23.86-15.369 25.15 25.15 0 0 1 0-19.572 25.15 25.15 0 0 1 14.024-13.652 25.2 25.2 0 0 1 9.836-1.717c13.541.474 24.276 11.586 24.284 25.137.006 13.549-10.718 24.672-24.259 25.16"
    />
  </svg>
);
export default SvgHubspotLogoIcon;
